import * as Sentry from '@sentry/browser';

// Init?
if(process.env.MIX_SENTRY_LARAVEL_DSN & process.env.MIX_SENTRY_LARAVEL_DSN !== '')
    Sentry.init({
        dsn: process.env.MIX_SENTRY_LARAVEL_DSN,
    });